import React from "react";

interface SummarySectionProps {
  summary: string;
}

const SummarySection: React.FC<SummarySectionProps> = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">Resumen</h3>
      <div className="rounded-lg bg-blue-50 p-4 text-navy-700">
        {summary}
      </div>
    </div>
  );
};

export default SummarySection; 